module.exports = __webpack_public_path__ + "static/media/last.139c6b32.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/last.svg
// module id = 223
// module chunks = 0